import { MODELS_COMPARE } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  models: [],
  fetchModelsStatus: undefined,
  fetchModelsError: undefined,
  equalType: null,
  quantiles: 0,
  quantileIndices: [],
  liftScores: [],
  availableQuantiles: {
    current: [],
  },
  chart: CONSTANTS.TAL_MODEL.CHARTS.TORNADO_BAR_CHART,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODELS_COMPARE.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case MODELS_COMPARE.RESET_PAGE:
      return INITIAL_STATE;
    case MODELS_COMPARE.FETCH_MODELS:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_COMPARE.FETCH_MODELS_SUCCEEDED:
      return {
        ...state,
        models: action.payload,
        fetchModelsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_COMPARE.FETCH_MODELS_FAILED:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_COMPARE.SET_EQUAL_TYPE:
      return {
        ...state,
        equalType: action.payload,
      };
    case MODELS_COMPARE.SET_QUANTILES:
      return {
        ...state,
        quantiles: action.payload,
        quantileIndices: state.liftScores
          .map((liftScores) => liftScores.map((liftScore) => liftScore?.percentile?.length))
          .map((lengths) => lengths.findIndex((len) => len === action.payload)),
      };
    case MODELS_COMPARE.SET_LIFT_SCORES:
      return {
        ...state,
        liftScores: action.payload,
      };
    case MODELS_COMPARE.SET_QUANTILE_INDICES:
      return {
        ...state,
        quantileIndices: action.payload,
      };
    case MODELS_COMPARE.SET_AVAILABLE_QUANTILES:
      return {
        ...state,
        availableQuantiles: action.payload,
      };
    case MODELS_COMPARE.SET_CHART:
      return {
        ...state,
        chart: action.payload,
      };
    default:
      return state;
  }
};
